import { render, staticRenderFns } from "./xcxPut.vue?vue&type=template&id=1333906c&scoped=true"
import script from "./xcxPut.vue?vue&type=script&lang=js"
export * from "./xcxPut.vue?vue&type=script&lang=js"
import style0 from "./xcxPut.vue?vue&type=style&index=0&id=1333906c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1333906c",
  null
  
)

export default component.exports